/**
 * 环境说明
 * 生产环境：生产环境，须保持稳定
 * 预发布环境：只作为开发预发布验证使用，快速验证发布
 * 本地环境：各开发同学自己的本地环境
 */
import { computed, ref } from 'vue';
import { getQueryString } from '@/utils/url';
import { cgiModeMap, webModeMap } from '@/service/const';

type EnvString = 'prerelease' | 'production' | 'test' | 'dev';
export function getEnvConfig() {
  const { env } = useEnv();
  const origin = cgiModeMap[env.value];
  return {
    apiBaseUrl: `https://${origin}`,
    cookieDomain: origin,
    secure: true,
    env: env.value,
  }
}

export function useEnv() {
  const env = ref<EnvString>('production');
  const { host } = location;
  const isProduction = host === webModeMap.production;
  const isPrerelease = host === webModeMap.prerelease;
  const isTest = host === webModeMap.test;
  switch (true) {
    case isProduction:
      env.value = 'production';
      break;
    case isPrerelease:
      env.value = 'prerelease';
      break;
    case isTest:
      env.value = 'test';
      break;
    default:
      env.value = 'dev';
      break;
  }

  function getIsDev() {
    return env.value === 'dev';
  }

  const isDev = computed(() => getIsDev());

  return {
    getIsDev,
    isDebug: +getQueryString('debug') === 1,
    isPrerelease,
    isProduction,
    isDev,
    // 本地环境暂时默认使用mock
    isUseMockData: getIsDev() && getQueryString('is_use_mock_data') === '1',
    env,
  };
}

export const isLocal = window.location.hostname.startsWith('localhost');
